import type { Tool } from "@repo/app-types/entities/tool";
import { useMemo } from "react";
import { useAllToolsQuery } from "../api/entities/tool.js";

/**
 * Hook that fetches all tools and returns them as a Map keyed by tool ID.
 * Useful for looking up tool names and other metadata by ID.
 */
export const useAllToolsById = (): ReadonlyMap<string, Tool> => {
  const { data: allTools } = useAllToolsQuery();

  return useMemo(() => {
    const map = new Map<string, Tool>();
    for (const tool of allTools ?? []) {
      map.set(tool.id, tool);
    }
    return map;
  }, [allTools]);
};
